import script from "./ProductDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProductDetails.vue?vue&type=style&index=0&id=100bdf9e&lang=css"

const __exports__ = script;

export default __exports__